// extracted by mini-css-extract-plugin
export var activeDot = "_39-c";
export var buttonContainer = "_39-9";
export var channelButton = "_39-a";
export var clickable = "_39-d";
export var content = "_39-0";
export var contentFull = "_39-2";
export var contentThird = "_39-1";
export var contentWrapper = "_39-7";
export var description = "_39-5";
export var heightShort = "_39-f";
export var image = "_39-3";
export var imageContainer = "_39-4";
export var selectButton = "_39-e";
export var spinnerContainer = "_39-b";
export var titleContent = "_39-8";
export var titleWrapper = "_39-6";